const initialState = {
    miniList: [],
    loaded: false
}

export const miniReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'GET_ALL_MINIS': return {
            ...state,
            miniList: action.payload
        }
        case 'MINIS_LOADED': return {
            ...state,
            loaded: action.payload
        }
        default: return state
    }
}